module.exports = __webpack_public_path__ + "static/img/Callaghan.7eaaf2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Callaghan.jpg
// module id = 6xFw
// module chunks = 0